<div class="tournament-unfinished-games-pop-up-container">
    <ds-modal inverse="false">
        <ds-modal-header variant="surface-high">
            <div slot="start">
                <span class="title">{{ preventPopupTitle }}</span>
            </div>
            <button
                slot="end"
                data-testid="close-button"
                class="close-button"
                ds-button
                size="medium"
                variant="outline"
                kind="secondary"
                (click)="close()">
                {{ preventPopupClose }}
            </button>
        </ds-modal-header>
        <ds-modal-content>
            <div class="dialog-content">
                <div class="image-container-parent">
                    <div class="image-container">
                        <div class="prevent-icon">
                            <img src="{{ preventIconSrc }}" alt="prevent-icon" />
                        </div>
                        <div
                            class="tournament-unfinished-game-container-{{
                                tournamentUnfinishedGames?.length === 1 ? 'single' : 'stacked'
                            }} tournament-unfinished-game-container">
                            @for (game of tournamentUnfinishedGames; track game.gameId) {
                                <img src="{{ game.icon }}" alt="{{ game.gameId }}" class="game-image" />
                            }
                        </div>
                    </div>
                    <div class="radial-shadow-container">
                        <img src="{{ radialShadowSrc }}" alt="prevent-icon" />
                    </div>
                </div>
                <ds-modal-content class="description">
                    <span class="description-text">
                        {{ tournamentUnfinishedGames?.length === 1 ? preventPopupSingleGameDescription : preventPopupMultipleGameDescription }}
                    </span>
                </ds-modal-content>
            </div>
            <div class="bottom-button-container">
                <button
                    data-testid="launch-game-button"
                    class="launch-game-button w-100"
                    ds-button
                    size="large"
                    variant="filled"
                    kind="primary"
                    inverse="false"
                    (click)="launchUnfinishedGame(tournamentUnfinishedGames[0]?.gameId)">
                    {{ preventPopupLaunchUnfinishedGame }}
                </button>
            </div>
        </ds-modal-content>
    </ds-modal>
</div>
